import React, { useEffect } from "react";
import { useStateContext } from "../../contexts/ContextProvider";

const ContestIntro = ({ contest }) => {
  let genre = null;
  const { genres, getGenres } = useStateContext();
  genre = genres.filter((g) => g._id === contest.genre)[0]?.name;

  useEffect(() => {
    getGenres();
  }, []);

  return (
    <div className="w-full lg:px-12 md:px-6 px-3 pt-8">
      <div className="flex justify-center text-center mb-8 w-full">
        <p className="md:text-3xl text-xl font-bold text-white">
          {contest.contestName} <br />{" "}
          <span className="md:text-2xl text-xl">{genre && `(Genre ${genre})`}</span>
        </p>
      </div>
      <div className="lg:flex lg:flex-row justify-between text-center">
        <div className="flex justify-center w-full">
          <img
            src={contest.imgLink}
            alt=""
            className="lg:w-96 lg:h-96 w-56 h-56 lg:mb-12 mb-6"
          />
        </div>

        <div className="w-full lg:px-3 px-5">
          <p className="font-semibold underline md:text-xl text-md">
            VOTING IN THIS CONTEST
          </p>
          <div className="text-left my-5">
            <p className="md:text-lg text-md">
              1. This Contest Has 8 Artists Competing in 3 Rounds & Each Round
              Lasts 72 Hours <br />
              2. Listen to Every Song in the Round <br />
              3. Vote for Your Favorite Artist From Each Pair Until You've
              Finished Voting
            </p>
          </div>

          <p className="font-semibold underline md:text-xl text-md">PRIZE</p>
          <div className="text-left my-5 md:text-lg text-md">
            <p>
              Artists Compete For Prizes Including Newsletter Coverage, Ads On
              The Soundoff Website, And More!
            </p>
          </div>
          <div className="flex justify-center items-center mt-8">
            <a
              href={`/song/1/${contest._id}`}
              class="md:w-1/2 w-full p-3 cursor-pointer hover:bg-green-600 border-rounded text-white font-medium md:text-md text-xs leading-tight uppercase md:rounded-sm rounded-md bg-blue-600 focus:outline-none focus:ring-0 transition duration-150 ease-in-out"
            >
              <p className="font-semibold text-md">Enter Contest</p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContestIntro;
